const initialState = {
  loadingGetPortalBasicSettings: false,
  errorGetPortalBasicSettings: false,
  portalData: null,
  loadingGetPortalConfigurations: false,
  errorGetPortalConfigurations: false,
  portalConfigutations: null,
  loadingUpdatePortalConfigurations: false,
  errorUpdatePortalConfigurations: false,
  loadingGetPortalRulesSummary: false,
  errorGetPortalRulesSummary: false,
  portalRulesSummary: null,
  isDevelopmentPortal: false,
  starringRulesShowInactive: false,
  starringRuleForm: {
    currentStep: 1,
    ruleName: '',
    isEditing: true,
    isValid: false,
    errorMessage: '',
    isActive: true,
    selectedPropertyTypes: [],
    selectedCharacteristic: null,
    showPropertyTypeCriteria: false,
    showNameInput: true,
    showCriteriaSection: false,
    showTypePublication: false,
    showCharacteristicsList: false,
    showAddCriterionButton: false,
    publicationType: null,
    selectedXml: null,
    selectedXmlIsDefault: false,
    selectedXmlKeys: null,
    showXmlSelector: false,
    selectedAttributes: [],
    attributeValues: {},
    attributeTagIdMap: {},
    showAttributesCriteria: false,
    selectedOperationType: null,
    showOperationTypeCriteria: false,
    selectedPrice: null,
    showPriceCriteria: false,
    selectedLocations: [],
    showLocationCriteria: false,
    selectedProperties: [],
    showPropertiesCriteria: false,
    selectedBranches: [],
    showBranchCriteria: false,
    selectedImportedFrom: [],
    showImportedFromCriteria: false,
    selectedAgentsInCharge: [],
    showAgentsInChargeCriteria: false,
    criteriaOrder: [],
    removedCriteria: [],
    hasValidationErrors: false,
    attributeValidationErrors: {},
  },
  loadingCreateRule: false,
  errorCreateRule: false,
  loadingGetRule: false,
  errorGetRule: false,
  editingRuleData: null,
  loadingPatchRule: false,
  errorPatchRule: false,
  loadingGetStarringRules: true,
  errorGetStarringRules: false,
  activeStarringRulesCount: 0,
  starringRules: [],
  propertyTypes: [],
  totalPropsMatchingCriteria: 0,
  totalPropsMatchingNotApplying: 0,
  propsIdsMatchingCriteria: [],
  propIdsMatchingCriteriaRequestId: null,
  currentAffectedProperties: [],
  loadingAffectedProperties: false,
  errorAffectedProperties: false,
  updatingRules: false,
  errorUpdatingRules: false,
  loadingGetAttributes: false,
  errorGetAttributes: false,
  attributes: [],
  selectOptions: {},
  loadingSelectOptions: {},
  developmentTypes: [],
  loadingGetDevelopmentTypes: false,
  errorGetDevelopmentTypes: false,
  locationSearchResults: [],
  loadingLocationSearch: false,
  errorLocationSearch: false,
  customTagsData: [],
  loadingCustomTags: false,
  errorCustomTags: false,
  loadingRequestUpgrade: false,
  errorRequestUpgrade: false,
  loadingGetUpgradePending: false,
  errorGetUpgradePending: false,
  upgradePending: false,
  activeTab: null,
  loadingAddXmlFile: false,
  errorAddXmlFile: false,
  loadingDeleteXmlFile: false,
  errorDeleteXmlFile: false,
  xmlFiles: [],
  loadingGetXmlFiles: false,
  errorGetXmlFiles: false,
  importedFromOrigins: [],
  loadingGetImportedFromOrigins: false,
  errorGetImportedFromOrigins: false,
  xmlFileHistory: [],
  loadingGetXmlFileHistory: false,
  errorGetXmlFileHistory: false,
};

export default initialState;
